/* mobile/check
 ========================================================================== */
export const MOBILE_BREAKPOINT = 767;
export const TABLET_BREAKPOINT = 1023;
export const desktopMediaQueryListener = window.matchMedia(`(min-width: ${TABLET_BREAKPOINT + 1}px)`);
export default function isMobileDisplay(breakpoint = MOBILE_BREAKPOINT) {
    return window.innerWidth <= breakpoint;
}
export function isDesktopDisplay(breakpoint = TABLET_BREAKPOINT) {
    return window.innerWidth > breakpoint;
}
